import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 7 6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentcolor",
      d: "M7 3 4.346.346a.564.564 0 1 0-.797.797l1.293 1.293H.564a.564.564 0 1 0 0 1.128h4.278L3.549 4.857a.563.563 0 1 0 .797.798z"
    }, null, -1)
  ]))]))
}
export default { render: render }